import posthog from "posthog-js";

const key = import.meta.env.VITE_POSTHOG_KEY;
const host = import.meta.env.VITE_POSTHOG_HOST;

if (!key || !host) {
  throw new Error("PostHog env variables are not set. Check your .env file.");
}

posthog.init(key, {
  api_host: host,
  person_profiles: "identified_only",
  capture_pageview: true,
  capture_pageleave: true,
});

export default posthog;
